<template>
  <AppLayout>
    <div class="inventory">
      <section id="suppliers-add">
        <div class="container">
          <h3>Reserve Stock</h3>
          <div>
            <div class="form">
              <div class="row">
                <strong>1. Product to be reserved</strong>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="address">Product Description</label>
                    <input type="text" id="address" class="form-control" readonly :value="inventory.Product?.name">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Product Code</label>
                    <input type="text" id="address" class="form-control" readonly :value="inventory.Product?.code">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Unit</label>
                    <input type="text" id="address" class="form-control" readonly :value="inventory.Product?.unit?.unit">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Qty Avail</label>
                    <input type="text" id="address" class="form-control" readonly :value="inventory.quantity">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="address">Warehouse</label>
                    <input type="text" id="address" class="form-control" readonly :value="inventory.Warehouse?.name">
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="address">Qty to Reserve</label>
                    <input type="number" min="0" id="address" class="form-control" v-model="quantity">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="address">Comment</label>
                    <input type="text" id="address" class="form-control" v-model="comment">
                  </div>
                </div>

                <div class="col-md-2">
                    <button class="btn-style small" style="margin-top: 35px" @click="postProcess">Process</button>
                </div>
  
              </div>
  
            </div>
          </div>
        </div>
        </section>
    </div>
  </AppLayout>
  </template>
  
  <script>
  import { mapGetters, mapActions } from 'vuex'
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  
  export default {
    name: 'StockReserved',
    components: {
      AppLayout,
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        inventoryId: "",
        inventory:"",
        comment: "",
        quantity: "",
    }),
    computed:{
        ... mapGetters (["getWarehouses"]),
        warehouses () { return this.getWarehouses },
    },
    mounted(){
        this.fetchWarehouses(),
        this.inventoryId = this.$route.params.id
        this.setupInventory(this.inventoryId)
    },
    methods:{
        ... mapActions(['fetchWarehouses',]),
        async setupInventory(inventoryId){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/inventory/'+inventoryId, requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.inventory = data.inventory;
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Stock Details not found. Try again',
                    text: data.message
                })
            }
        },

        async postProcess() {
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                quantity: this.quantity,
                comment: this.comment,
                productId: this.inventory.Product?.id,
                inventoryId: this.inventoryId,
              })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/stockreserved', requestOptions)
          const data = await res.json()
          if(data.status == true){
            Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Stock Reservation Processed',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push('/inventory/stocks')        
          }else{
            Swal.fire({
                icon: 'error',
                title: 'Stock Reservation not created',
                text: data.message
            })
          }
        }
        
    }
  }
</script>
<style scoped>

input[readonly]{
  background-color: #cfcece !important;
}
</style>